import { render, staticRenderFns } from "./TrainingRecordExpiryNotesModal.vue?vue&type=template&id=71002aea&scoped=true&"
import script from "./TrainingRecordExpiryNotesModal.vue?vue&type=script&lang=js&"
export * from "./TrainingRecordExpiryNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRecordExpiryNotesModal.vue?vue&type=style&index=0&id=71002aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71002aea",
  null
  
)

export default component.exports